module.exports = __webpack_public_path__ + "static/peter-attia-7cf462cf3afba3b0698a813b8926789c.jpg";